import { useCallback, useEffect, useRef, useState } from 'react';

const PARAM_PREFIX = 'admin.';

function readParam(key, fallback, parse) {
  if (typeof window === 'undefined') return fallback;
  const raw = new URLSearchParams(window.location.search).get(PARAM_PREFIX + key);
  if (raw == null || raw === '') return fallback;
  try {
    return parse ? parse(raw) : raw;
  } catch {
    return fallback;
  }
}

/**
 * Хранит состояние админки в query-параметрах вида ?admin.tab=tech.
 * Плюсы: F5 не сбрасывает вкладку/фильтры, ссылкой можно поделиться.
 * Значение по умолчанию из URL убирается, чтобы адрес оставался коротким.
 */
export function useAdminUrlState(key, fallback, { parse, serialize } = {}) {
  const fallbackRef = useRef(fallback);
  const [value, setValue] = useState(() => readParam(key, fallbackRef.current, parse));

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    const param = PARAM_PREFIX + key;
    const serialized = serialize ? serialize(value) : value;
    const defaultSerialized = serialize ? serialize(fallbackRef.current) : fallbackRef.current;

    if (value == null || serialized === defaultSerialized || serialized === '') {
      url.searchParams.delete(param);
    } else {
      url.searchParams.set(param, serialized);
    }
    window.history.replaceState(window.history.state, '', url);
  }, [key, value, serialize]);

  const update = useCallback((next) => {
    setValue((prev) => (typeof next === 'function' ? next(prev) : next));
  }, []);

  return [value, update];
}
